import { Component, DOCUMENT, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ApiService } from '@any2any/platform-api';
import { LocaleService } from '@any2any/shared';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { appIcons } from './app.icons';
import { ConfigService } from './core/services/config.service';
import { ThemeService } from './core/services/theme.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet]
})
export class AppComponent {

  private readonly configService = inject(ConfigService);
  private readonly themeService = inject(ThemeService);
  private readonly apiService = inject(ApiService);
  private readonly localeService = inject(LocaleService);

  constructor() {
    const library = inject(FaIconLibrary);
    const document = inject<Document>(DOCUMENT);

    appIcons(library);
    this.apiService.setApiUrl(this.configService.BASE_URL);
    this.themeService.initialize();
    this.localeService.initialize(document.querySelector('html')!);
  }

}
